var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckYourEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 110,
    viewBox: "0 0 342 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.4999C27 32.3332 80.4 31.5999 86 69.9999C93 118 1 122.499 20.5 80.9994C33 57.9997 46.5 40.9997 119 25.4994C185 12.9998 285 20.5 326.5 46.5007C350 60 355.9 91.3997 261.5 76.9997",
    stroke: "#E0E0E0",
    strokeDasharray: "10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171 0L123 43.0588L159 79.7647H180.176L219 43.0588L171 0Z",
    fill: "#53B741"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1314_614)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.294,
    y: 12,
    width: 74.8235,
    height: 74.8235,
    rx: 3,
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.544,
    y: 12.25,
    width: 74.3235,
    height: 74.3235,
    rx: 2.75,
    stroke: "#DFDFDF",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219 108H123L162.529 76.9414H179.471L219 108Z",
    fill: "#53B741"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219 43.0588L219 108L179.471 76.9412L219 43.0588Z",
    fill: "#7ED96E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123 43.0588L123 108L162.529 76.9412L123 43.0588Z",
    fill: "#7ED96E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.624 56.44C169.872 56.44 167.472 56.04 165.424 55.24C163.408 54.44 161.728 53.352 160.384 51.976C159.072 50.568 158.096 49 157.456 47.272C156.816 45.544 156.496 43.768 156.496 41.944C156.496 39.992 156.832 38.088 157.504 36.232C158.208 34.376 159.232 32.696 160.576 31.192C161.952 29.688 163.616 28.488 165.568 27.592C167.552 26.696 169.824 26.248 172.384 26.248C174.784 26.248 176.832 26.6 178.528 27.304C180.256 28.008 181.664 28.952 182.752 30.136C183.84 31.32 184.64 32.648 185.152 34.12C185.664 35.592 185.92 37.096 185.92 38.632C185.92 40.072 185.696 41.48 185.248 42.856C184.8 44.232 184.16 45.464 183.328 46.552C182.496 47.608 181.52 48.44 180.4 49.048C179.312 49.656 178.096 49.944 176.752 49.912C176.336 49.88 175.952 49.768 175.6 49.576C175.28 49.384 175.024 49.064 174.832 48.616C174.64 48.168 174.528 47.592 174.496 46.888C173.856 47.88 173.088 48.632 172.192 49.144C171.328 49.656 170.384 49.912 169.36 49.912C168.272 49.912 167.248 49.64 166.288 49.096C165.328 48.52 164.544 47.688 163.936 46.6C163.328 45.48 163.024 44.136 163.024 42.568C163.024 40.968 163.344 39.416 163.984 37.912C164.624 36.376 165.568 35.112 166.816 34.12C168.096 33.096 169.68 32.584 171.568 32.584C172.592 32.584 173.52 32.856 174.352 33.4C175.184 33.912 175.776 34.68 176.128 35.704L176.704 32.968H179.824L177.424 43.96C177.2 45.08 177.104 45.912 177.136 46.456C177.168 47 177.312 47.288 177.568 47.32C177.984 47.384 178.496 47.24 179.104 46.888C179.744 46.504 180.352 45.944 180.928 45.208C181.536 44.44 182.048 43.512 182.464 42.424C182.88 41.304 183.088 40.04 183.088 38.632C183.088 36.936 182.672 35.352 181.84 33.88C181.04 32.376 179.824 31.16 178.192 30.232C176.592 29.304 174.608 28.84 172.24 28.84C169.808 28.84 167.632 29.4 165.712 30.52C163.824 31.64 162.336 33.192 161.248 35.176C160.16 37.16 159.616 39.432 159.616 41.992C159.616 44.392 160.112 46.488 161.104 48.28C162.128 50.04 163.6 51.432 165.52 52.456C167.472 53.448 169.84 53.944 172.624 53.944C174.352 53.944 175.936 53.72 177.376 53.272C178.816 52.824 180.112 52.168 181.264 51.304L182.896 53.224C181.552 54.248 180.048 55.032 178.384 55.576C176.72 56.152 174.8 56.44 172.624 56.44ZM169.936 47.416C170.928 47.416 171.824 47.032 172.624 46.264C173.424 45.464 174.048 44.44 174.496 43.192C174.976 41.944 175.216 40.68 175.216 39.4C175.216 38.056 174.864 37.016 174.16 36.28C173.456 35.512 172.496 35.128 171.28 35.128C170.192 35.128 169.264 35.512 168.496 36.28C167.728 37.016 167.136 37.96 166.72 39.112C166.336 40.264 166.144 41.432 166.144 42.616C166.144 43.896 166.448 45.016 167.056 45.976C167.696 46.936 168.656 47.416 169.936 47.416Z",
    fill: "#7ED96E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.733 77.6424L245.25 74.0391L261.983 81.1977L268.733 77.6424Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.859 71.3552L244.63 73.9604L262.533 76.8572L263.859 71.3552Z",
    fill: "#BCBCBC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1314_614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 15.4695C116.624 13.8833 113.347 10.1618 111.5 3.93899C109.951 10.2228 106.316 13.7003 100 15.5305C106.137 17.2387 109.712 20.7162 111.381 27C113.466 21.0822 116.982 17.4218 123 15.4695Z",
    fill: "#7ED96E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1314_614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.093 44.527C255.909 43.4861 253.759 41.0439 252.547 36.9603C251.53 41.084 249.145 43.366 245 44.5671C249.028 45.6881 251.374 47.9701 252.468 52.0938C253.837 48.2103 256.144 45.8082 260.093 44.527Z",
    fill: "#7ED96E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1314_614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.605 31.7903C244.942 31.1279 243.574 29.5738 242.802 26.9751C242.155 29.5992 240.638 31.0514 238 31.8158C240.563 32.5291 242.056 33.9813 242.753 36.6055C243.624 34.1342 245.092 32.6056 247.605 31.7903Z",
    fill: "#7ED96E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1314_614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6049 28.7903C96.9424 28.1279 95.5738 26.5738 94.8024 23.9751C94.1555 26.5992 92.6376 28.0514 90 28.8158C92.563 29.5291 94.056 30.9813 94.7527 33.6055C95.6236 31.1342 97.0917 29.6056 99.6049 28.7903Z",
    fill: "#7ED96E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1314_614",
    x: 132.294,
    y: 10,
    width: 78.8235,
    height: 78.8232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1314_614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1314_614",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1314_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 100 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1314_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0934,
    height: 15.0934,
    fill: "white",
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 245 52.0938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1314_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.60489,
    height: 9.60489,
    fill: "white",
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 238 36.6055)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1314_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.60489,
    height: 9.60489,
    fill: "white",
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 90 33.6055)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckYourEmail);
export default __webpack_public_path__ + "static/media/checkYourEmail.729a993d2880352aae83e1d15e3508c5.svg";
export { ForwardRef as ReactComponent };